<template>
  <div class="lang-menus">
    <span
      @click="toggleLang('en-US')"
      :class="{ lang: true, 'selected-lang': selectedLang == 'en-US' }"
    >
      EN
    </span>
    <span class="line"></span>
    <span
      @click="toggleLang('zh-CN')"
      :class="{ lang: true, 'selected-lang': selectedLang === 'zh-CN' }"
    >
      中文
    </span>
  </div>
</template>

<script>
  import store from '@/store'
  export default {
    name: 'PrLang',
    computed: {
      selectedLang() {
        return store.getters['settings/currentLang']
      },
    },
    methods: {
      toggleLang(lang) {
        this.$store.dispatch('settings/changeLanguage', lang)
        location.reload()
      },
    },
    mounted() {
      // 加载默认语言
    },
  }
</script>

<style lang="less">
  .lang-menus {
    color: white;
    width: 80px;
    display: flex;
    justify-content: space-between;
    margin-left: 25px;
    align-items: center;

    .lang {
      cursor: pointer;
    }

    .selected-lang {
      color: @primary-color;
      text-decoration: underline;
    }

    .line {
      height: 14px;
      width: 1px;
      background-color: white;
    }
  }
</style>
